import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'translations/hooks';

import { useGenerateGraphs } from 'business/data-analysis/pages/graph/hooks/use-generate-graphs';
import { useMode } from 'business/data-analysis/pages/graph/hooks/use-mode';
import { GraphFilters } from 'business/data-analysis/pages/graph/types';
import { isFetchingDisabled } from 'business/data-analysis/services/is-fetching-disabled';
import { useMediaType } from 'technical/media/hooks';
import Button from 'ui/button';

import styles from './index.module.scss';

interface Props {
  atLeastOneParameterIsSelected: boolean;
  filters: GraphFilters;
}

export const GenerateGraphsButton = ({
  atLeastOneParameterIsSelected,
  filters,
}: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useMediaType();

  const mode = useMode();

  const { generateGraphs, isFetching } = useGenerateGraphs(filters);

  const generateButtonIsDisabled = isFetchingDisabled({
    isFetching,
    atLeastOneParameterIsSelected,
    filters,
    mode,
  });

  return (
    <Button
      icon={<ReloadOutlined />}
      onClick={generateGraphs}
      disabled={generateButtonIsDisabled}
      className={styles.generateGraphButton}
    >
      {t('dataAnalysis.actions.generateGraphs', {
        context: isMobile ? 'single' : undefined,
      })}
    </Button>
  );
};
